var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-modal-no-thanks.j2"] = require( "loyalty-modal-no-thanks.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-submit.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"o-row\">\n    <div class=\"g-loyalty-form__submit\">\n\n        <div class=\"c-form__field\">\n\n            <button class=\"c-button-primary c-loyalty__button js-generic-email-submit js-loyalty-submit-button\" type=\"submit\" data-qa-loyalty-submit-button>\n                ";
output += runtime.suppressValue((lineno = 8, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_submit-button"])), env.opts.autoescape);
output += "\n            </button>\n\n        </div>\n\n    </div>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "loyaltyModal")) {
output += "\n\n        ";
env.getTemplate("loyalty-modal-no-thanks.j2", false, "loyalty/templates/loyalty-submit.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n    ";
})});
}
output += "\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"g-loyalty-form__contact\">\n\n        <p class=\"u-text-details c-loyalty__fine-print\">\n            ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 28, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_submit-message"]))), env.opts.autoescape);
output += "\n        </p>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-submit.j2"] , dependencies)